<template>
  <div class="record-list">
    <div class="record-list__header" :style="listHeaderStyle">
      <div class="record__status">{{ $t('records.list.headers.status') }}</div>
      <div class="record__create-by" v-if="employee">{{ $t('create_by') }}</div>
      <div class="record__address">{{ $t('records.list.headers.path') }}</div>
      <div class="record__price">{{ $t('records.list.headers.total_price') }}</div>
      <div class="record__cod">{{ $t('records.list.headers.total_cod') }}</div>
      <div class="record__stages">{{ $t('records.list.headers.callback') }}</div>
    </div>
    <div class="record-list__body custom-scrollbar">
      <RecordRow
        v-for="order in orders"
        :key="order._id"
        :order="order"
        :employee="employee"
        @onClick="handleClickRecord"
      />

      <!-- Loading indicator -->
      <div v-if="loading" class="record-list__loading">
        <v-progress-circular indeterminate color="#FF8200" :width="2" :size="20" />
        <span>{{ $t('loading') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import RecordRow from './list_view/RecordRow'
import { removeUnicode } from '@/plugins/util'

export default {
  name: 'ListView',
  components: {
    RecordRow
  },
  props: {
    loading: {
      type: Boolean
    },
    employee: {
      type: Boolean
    },
    orders: {
      type: Array,
      required: true
    },
    onGoToDetail: {
      type: Function
    },
    onScrollToBottom: {
      type: Function
    },
    searchText: {
      type: String
    }
  },
  computed: {
    ...mapState({
      scrollBarWidth: (state) => state.scrollBarWidth
    }),
    listHeaderStyle() {
      if (this.scrollBarWidth) {
        return { paddingRight: `${this.scrollBarWidth}px` }
      } else return {}
    }
  },
  methods: {
    handleClickRecord() {
      // this.$emit("onGoToDetail");
      // console.log('handleClickRecord', data)
      // this.$store.dispatch("setOrderId", order._id);
    },
    highlight(text) {
      let inputID = document.getElementsByClassName('record__id__up')
      for (let i = 0; i < inputID.length; i++) {
        let item = inputID[i]
        let innerHTML = item.innerHTML
        const formatText = removeUnicode(text.toUpperCase())
        const formatHtml = removeUnicode(innerHTML)
        let index = formatHtml.indexOf(formatText)

        if (index >= 0) {
          innerHTML =
            innerHTML.substring(0, index) +
            '<mark>' +
            innerHTML.substring(index, index + text.length) +
            '</mark>' +
            innerHTML.substring(index + text.length)
          item.innerHTML = innerHTML
        }
      }

      let inputAddress = document.getElementsByClassName('record__address')
      for (let i = 0; i < inputAddress.length; i++) {
        let item = inputAddress[i]
        let innerHTML = item.innerHTML
        const formatText = removeUnicode(text.toLowerCase())
        const formatHtml = removeUnicode(innerHTML.toLowerCase())
        let index = formatHtml.indexOf(formatText)

        if (index >= 0) {
          innerHTML =
            innerHTML.substring(0, index) +
            '<mark>' +
            innerHTML.substring(index, index + text.length) +
            '</mark>' +
            innerHTML.substring(index + text.length)
          item.innerHTML = innerHTML
        }
      }
    }
  },
  mounted() {
    this.searchText && this.highlight(this.searchText)
  }
}
</script>

<style lang="scss">
$record-list__header__height: 40px;

.record-list {
  height: 100%;

  .record-list__header {
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #7a8189;
    align-items: center;
    padding: 0 30px;

    > div {
      padding: 0 3px;
    }

    .record__address {
      padding: 0 15px;
    }
  }

  .record-list__header,
  .record-list__row {
    display: flex;

    .record__id {
      padding-left: 20px;
      width: 116px;
    }

    .record__address {
      flex: 1;
    }

    .record__create-at,
    .record__create-by {
      width: 180px;
    }

    .record__status {
      width: 160px;
      padding: 0 10px;
    }

    .record__cod {
      width: 160px;
      text-align: center;
    }

    .record__price {
      width: 160px;
      text-align: center;
    }

    .record__stages {
      width: 200px;
      text-align: center;
    }
  }

  .record-list__body {
    height: calc(100% - #{$record-list__header__height});
    overflow-y: scroll;
    color: #1a1a1a;

    > a:first-child {
      .record-list__row-wrapper {
        // border-top: 1px solid #f2f2f2;
        // border: 1px solid #e0e0e0;
        // padding: 0;
        // margin: 20px 30px;
        // border-radius: 4px;
      }
    }

    > a {
      .record-list__row-wrapper {
        border: 1px solid #e0e0e0;
        padding: 0;
        margin: 20px 30px;
        border-radius: 4px;
      }
    }
  }

  .record-list__loading {
    text-align: center;
    padding: 20px 0;

    span {
      margin-left: 10px;
      color: #ff8200;
      font-size: 13px;
    }
  }
}
</style>
